module.exports = __webpack_public_path__ + "static/media/me.ac2243d7.jpg";